<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Add parent integration"></aw-bread-crumb>

  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'New Parent Integration'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="form-container">
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Parent Integration Name"
      (textEntry)="onNameSelected($event)"
    ></app-aw-text-form>

    <app-aw-dropdown-form
      class="input"
      [options]="statusOptions()"
      title="Status"
      (currentOption)="onStatusSelected($event)"
    ></app-aw-dropdown-form>
  </div>

  <div class="employee-auth-details-container">
    <aw-divider
      [inset]="false"
      [middleInset]="false"
      [subTitle]="'Employee Authentication (Required)'"
      [altColor]="true"
    >
    </aw-divider>

    <div class="auth-type-label">
      <label>Authentication Type: OpenID Connect</label>
    </div>

    <app-aw-auth-form
      [authType]="employeeAuthTypeValue"
      [values]="employeeAuthFieldsValues"
      [authenticationVersion]="'employee'"
      (valuesChangedEvent)="onEmployeeAuthValuesChanged($event)"
    ></app-aw-auth-form>
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"></aw-action-bar>
</div>
